import React, { Component } from 'react';

import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { AxiosError } from 'axios';

import * as Auth from '../services/AuthService';
import LoaderButton from '../components/utils/LoaderButton';
import '../styles/containers/Login.css';

export class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: '',
      password: '',
      error: '',
    };
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  handleSubmit = async event => {
    event.preventDefault();
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { email, password } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { logIn } = this.props;
    this.setState({ isLoading: true });

    try {
      const user = await Auth.login(email.toLowerCase(), password);
      const currentUser = await Auth.getMyProfile();
      if (currentUser.Item.role !== 'superAdmin') {
        Auth.logout();
        this.setState({
          isLoading: false,
          error: 'Incorrect username or password',
        });
      } else {
        logIn(user);
      }
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isLoading: false,
        error: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    }
  };

  validateForm() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { email, password } = this.state;
    return email.length > 0 && password.length > 0;
  }

  render() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { email, password, isLoading, error } = this.state;
    return (
      <div className='Login'>
        <form onSubmit={this.handleSubmit}>
          <span className='err'>{error}</span>
          <FormGroup controlId='email' bsSize='large'>
            <ControlLabel>Email</ControlLabel>
            <FormControl
              autoFocus
              type='text'
              value={email}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup controlId='password' bsSize='large'>
            <ControlLabel>Password</ControlLabel>
            <FormControl
              value={password}
              onChange={this.handleChange}
              type='password'
            />
          </FormGroup>
          <LoaderButton
            block
            bsSize='large'
            disabled={!this.validateForm()}
            type='submit'
            isLoading={isLoading}
            text='Login'
            loadingText='Logging in…'
          />
        </form>
      </div>
    );
  }
}
